import { useEffect, useState } from 'react';
import { Container, Row, Col, Button, FormGroup, Input, Label } from 'reactstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import AppBreadcrumb from '../../components/ui/AppBreadcrumb';
import { createProcedure, updateProcedure } from '../../redux/actions/procedures.actions';
import { getOneProcedure } from '../../services/proceduresService';
import { CLIENT_ADMIN_PROCEDURES } from '../../navigation/ROUTE_CONSTANTS';

function ClientAdminProcedureForm() {

    const dispatch = useDispatch();
    const { procedureId } = useParams();
    const [initialFornmValues, setInitialFornmValues] = useState({
        name: '',
        short_name: '',
        need_details: false,
    });
    const [pageTitle, setPageTitle] = useState('');

    useEffect(() => {
        if (procedureId) {
            setPageTitle('Edit Procedure');
            getOneProcedure(procedureId).then((data) => {
                setInitialFornmValues({
                    name: data.name,
                    short_name: data.short_name,
                    need_details: data.need_details,
                });
            })
        } else {
            setPageTitle('Create Procedure');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [procedureId]);

    useEffect(() => {
        document.title = process.env.REACT_APP_SITE_TITLE + ' - ' + pageTitle;
    }, [pageTitle]);

    return (
        <Container className='mb-5 pb-5'>
            <Row>
                <Col>
                    <AppBreadcrumb headText={pageTitle} crumbList={[{ linkTo: CLIENT_ADMIN_PROCEDURES, label: 'Procedures' }]} />
                </Col>
            </Row>

            <Row>
                <Col>
                    <div className='vstack col-md-4 mx-auto'>
                        <h4 className='pt-2 pb-3 text-center'>{pageTitle}</h4>
                        <Formik
                            enableReinitialize={true}
                            initialValues={initialFornmValues}
                            validationSchema={Yup.object({
                                name: Yup.string()
                                    .min(1, 'Name must be at least 1 characters length.')
                                    .max(120, 'Name must be smaller than 120 characters length.')
                                    .required('Please enter a name'),
                                short_name: Yup.string()
                                    .max(32, 'Name must be smaller than 32 characters length.')
                                    .nullable()
                                    .notRequired()
                            })}
                            onSubmit={(values) => {
                                let formData = {
                                    name: values.name,
                                    short_name: values.short_name,
                                    need_details: values.need_details,
                                }

                                if (procedureId) {
                                    formData.id = procedureId;
                                    dispatch(updateProcedure(formData));
                                } else {
                                    dispatch(createProcedure(formData));
                                }
                            }}
                        >{() => (
                            <Form>
                                <FormGroup>
                                    <Field type="text" name="name" placeholder="Name" as={Input} />
                                    <ErrorMessage component="div" className="text-danger" name="name" />
                                </FormGroup>
                                <FormGroup>
                                    <Field type="text" name="short_name" placeholder="Short name" as={Input} />
                                    <ErrorMessage component="div" className="text-danger" name="short_name" />
                                </FormGroup>
                                <FormGroup >
                                    <Field type="checkbox" id="need_details" name="need_details" as={Input} />
                                    <Label className='mx-2' check for="need_details">Require enter details</Label>
                                    <ErrorMessage component="div" className="text-danger" name="need_details" />
                                </FormGroup>
                                <div className='text-center'>
                                    <Button color='success' className='mt-2 px-5' type='submit'>
                                        <span className='d-inline-block fs-5 px-3'>{pageTitle}</span>
                                    </Button>
                                </div>
                            </Form>
                        )}
                        </Formik>
                    </div>
                </Col>
            </Row >

        </Container>
    )
}

export default ClientAdminProcedureForm;